import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "dt-mainCard__navigation-wrapper" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dt-mainCard__navigation", {'dt-mainCard__navigation_twoColumn': !$props.card.header.mapColumn}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["block-swiperNavigation", this.swiperId])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.card.content.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => ($options.onChange(tab)),
                class: "swiper-slide"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["block-swiperNavigation__item", {'active' : tab.id === $props.activeTab.id}])
                }, _toDisplayString(tab.name), 3 /* TEXT, CLASS */)
              ], 8 /* PROPS */, _hoisted_4))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _hoisted_5,
          _hoisted_6
        ], 2 /* CLASS */)
      ])
    ])
  ], 2 /* CLASS */))
}